export default __webpack_public_path__ + "89980786e6a20e6adf8f63f12e7d6e76.svg";